module.exports = __webpack_public_path__ + "img/venus14.f9a246de.png";